<template>
  <v-dialog
    :value="showRecordInfo"
    @input="v => v || HIDE_RECORD_INFO()"
    max-width="600px"
    scrollable
  >
    <v-card>
      <v-card-text class="pt-3 pb-2">
        <v-container>
          <h5 class="mb-2">رقم المشرف</h5>
          <p class="grey lighten-3 pa-2">{{ currentRecord.id }}</p>

          <h5 class="mb-2">الاسم</h5>
          <p class="grey lighten-3 pa-2">{{ currentRecord.name }}</p>

          <h5 class="mb-2">البريد الإلكتروني</h5>
          <p class="grey lighten-3 pa-2">{{ currentRecord.email }}</p>

          <h5 class="mb-2">نبذة</h5>
          <p class="grey lighten-3 pa-2">
            <template v-if="currentRecord.bio">{{ currentRecord.bio }}</template>
            <template v-else>لا يوجد</template>
          </p>

        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "record-info",


  computed: {
    ...mapState("admins", ['showRecordInfo', 'currentRecord'])
  },


  methods: {
    ...mapMutations("admins", ["HIDE_RECORD_INFO"]),
  }
};
</script>
